export const API_CONFIG = {
  path: {
    presignedUrl: '/uploads/presign',
    inboundFlow: '/packages/in',
    packageList: '/packages',
    outboundFlow: '/packages',
    slotList: '/slots',
    occupiedSlots: '/slots/occupied',
    availableSlots: '/slots/available',
    login: '/auth/login',
    profile: '/auth/profile',
    retrievePackage: '/packages/retrieve',
    analytics: '/packages/analytics',
    nextPackageNumbers: '/packages/next-numbers',
    storageSummary: '/packages/storage-summary',
  },
};
